import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Circle = styled.div<Theme>(({ theme }) => ({
  alignItems: 'center',
  borderRadius: '50%',
  color: theme.colors.grey.main,
  display: 'flex',
  fontSize: theme.typography.h3.fontSize,
  height: 50,
  justifyContent: 'center',
  width: 50,
  '&.first': {
    backgroundColor: theme.colors.white,
    border: `2px solid ${theme.colors.paletteFromBO.main}`,
    boxShadow: 'unset',
    color: theme.colors.paletteFromBO.main,
  },
  '&.disabled': {
    backgroundColor: theme.colors.grey.light,
    border: `2px solid ${theme.colors.grey.light}`,
    boxShadow: `0 0 10px 0 ${theme.colors.grey.light}`,
    color: theme.colors.white,
  },
  '&.done': {
    backgroundColor: theme.colors.paletteFromBO.main,
    border: `2px solid ${theme.colors.paletteFromBO.main}`,
    boxShadow: `0 0 10px 0 ${theme.colors.paletteFromBO.main}`,
    color: theme.colors.white,
  },
  '&.large': {
    boxShadow: '0 0 50px 0 inherit',
    fontSize: theme.typography.h2.fontSize,
    height: 90,
    width: 90,
  },
  '&.next': {
    backgroundColor: theme.colors.paletteFromBO.primary,
    border: `2px solid ${theme.colors.paletteFromBO.primary}`,
    boxShadow: `0 0 10px 0 ${theme.colors.paletteFromBO.primary}`,
    color: theme.colors.white,
  },
}));
